// src/reducers/userReducer.js
import {
    GET_GALLERY_SUCCESS,
    GET_GALLERY_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const galleryReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_GALLERY_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_GALLERY_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  